import styled from 'styled-components';
import { ApIcon, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
`;

export const Text = styled.div`
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const InfoIconWrapper = styled.span`
	visibility: hidden;
	position: absolute;
	top: 10px;
	left: 8px;
	height: 16px;
	width: 16px;
	cursor: pointer;

	svg {
		transition: none;

		&:hover {
			fill: ${colors.grey6};
		}
	}
`;

export const Cell = styled.div`
	position: relative;
	color: ${colors.grey5};
	min-width: 128px;
	display: flex;
	align-items: center;
	font-size: 13px;
	letter-spacing: 0.3px;
	line-height: 19px;
	border-right: 1px solid ${colors.grey2};
	height: 36px;

	&:first-child {
		padding-left: 32px;
	}
`;

export const CellIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 40px;
	visibility: hidden;
`;

export const Row = styled.div`
	display: grid;
	grid-template-columns: minmax(300px, 1fr) 128px;
	grid-auto-flow: column;
	width: fit-content;
	min-width: 100%;

	${({ selected }) => selected && `background-color: ${colors.green0}`};

	${({ isFaded }) => isFaded && 'opacity:0.2;'};

	&:hover {
		${InfoIconWrapper} {
			visibility: visible;
		}
	}
`;

export const HeaderRow = styled(Row)`
	&:hover {
		background-color: initial;
	}
`;

export const HeaderCell = styled(Cell)`
	font-size: 11px;
	line-height: 13px;
	color: ${colors.grey5};
	cursor: default;
`;

export const CellNumber = styled(Cell)`
	justify-content: flex-end;
	padding-right: 16px;
	max-width: 128px;

	span {
		padding-right: 6px;
	}
`;

export const HeaderCellNumber = styled(HeaderCell)`
	text-align: center;
	justify-content: center;
	padding: 0 4px;
	max-width: 90px;
`;

export const SpanWrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 128px;
	max-width: 128px;
	border-right: 1px solid ${colors.grey2};
`;

export const RowSpan = styled.div`
	display: flex;
	align-items: center;
	font-size: 11px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	width: 100%;
	height: 100%;
	border-bottom: 1px solid ${colors.grey2};

	&:last-child {
		border-bottom: none;
	}
`;

export const SpanColumn = styled.div`
	display: flex;
	align-items: center;
	border-right: 1px solid ${colors.grey2};
	width: 100%;
	height: 100%;

	&:last-child {
		border-right: none;
	}
`;

export const HeaderText = styled.div`
	width: 100%;
	text-align: center;
	font-size: 11px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
`;

export const NoData = styled.div`
	padding: 8px 24px;
`;

export const SortArrow = styled(ApIcon)`
	margin-left: 5px;
	transform: ${({ reverse }) => (reverse ? 'rotate(90deg)' : 'rotate(-90deg)')};
`;

export const SortIconSpace = styled.div`
	min-width: 18px;
`;

export const CheckboxWrapper = styled.div`
	padding-right: 16px;
`;

export const HeaderCellWrapper = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	width: 100%;
`;

export const HeaderScrollWrapper = styled.div`
	width: 100%;
	min-height: 36px;
	border-bottom: 1px solid ${colors.grey3};
	overflow: hidden;
`;

export const Content = styled.div`
	display: flex;
	height: 100%;
	width: 100%;
	overflow: hidden;
`;
